import { get } from '../utils/objectHelpers';
import {
    uxComponentsMapping,
    regionMapping,
    responseMapping,
    genFlatModule,
    defaultErrorMessages
} from './module-mappings';

export default function pullFlatModules(response, defaultLanguage, debug, draft = false) {
    const flatRegions = {};
    const regions = get(response, 'meta.pageTemplate.regions', {});
    const isSmall = get(response, 'meta.isSmall', false);
    const modules = get(response, 'modules', {});
    Object.keys(regions).forEach(regionKey => {
        const region = regions[regionKey];
        const usedRegionKey = regionMapping[regionKey] || regionKey;
        flatRegions[usedRegionKey] = [];
        if (region._type === 'Region' && region.layouts) {
            return Object.keys(region.layouts).forEach(layoutKey => {
                (region.layouts[layoutKey].positions).forEach(position => {
                    if (modules[position.moduleLocator]) {
                        flatRegions[usedRegionKey].push({
                            ...modules[position.moduleLocator],
                            _uxComponent: uxComponentsMapping[position.uxComponentName],
                            isSmall: isSmall,
                            __debug: debug,
                            __draft: draft
                        });
                    }
                });
            });
        }
    });
    if (debug) {
        flatRegions.diagnostics = modules.diagnostics;
    }
    Object.keys(responseMapping).forEach((moduleKey) => {
        flatRegions[moduleKey] = modules[responseMapping[moduleKey]];
    });

    if (!flatRegions.MAIN) {
        flatRegions.MAIN = generateMainRegion(response, defaultLanguage, isSmall, debug, draft);
    }
    addPropsToStoreTabs(flatRegions);
    addMetaData(flatRegions, response);
    return flatRegions;
}

function generateMainRegion(response, defaultLanguage, isSmall, debug, draft) {
    const region = [];
    const modules = get(response, 'modules', {});
    if (modules.STATUS_MESSAGE_MODULE) {
        region.push(
            genFlatModule(modules.STATUS_MESSAGE_MODULE, 'STATUS_MESSAGE', isSmall, debug, draft)
        );
    }
    if (modules.STORE_INFORMATION_MODULE && modules.TABS_MODULE) {
        region.push(
            genFlatModule(modules.STORE_INFORMATION_MODULE, 'STORE_INFORMATION', isSmall, debug, draft)
        );
        region.push(
            genFlatModule(modules.TABS_MODULE, 'STORE_TABS', isSmall, debug, draft)
        );
    }
    if (modules.SEARCH_THE_STORE_MODULE) {
        region.push(
            genFlatModule(modules.SEARCH_THE_STORE_MODULE, 'SEARCH_THE_STORE', isSmall, debug, draft)
        );
    }
    if (modules.SEEK_SURVEY_WEB_MODULE) {
        region.push(
            genFlatModule(modules.SEEK_SURVEY_WEB_MODULE, 'SEEK_SURVEY', isSmall, debug, draft)
        );
    }
    if (modules.SELLER_COMMS_MODULE) {
        region.push(
            genFlatModule(modules.SELLER_COMMS_MODULE, 'SELLER_COMMS', isSmall, debug, draft)
        );
    }
    if (modules.LOADING_SPINNER_MODULE) {
        region.push(
            genFlatModule(modules.LOADING_SPINNER_MODULE, 'LOADING_SPINNER', isSmall, debug, draft)
        );
    }
    if (region.length === 0 || response.error) {
        region.push(defaultErrorMessages[defaultLanguage] || defaultErrorMessages['en-US']);
    }
    return region;
}

function addPropsToStoreTabs(input) {
    const main = get(input, 'MAIN', []);
    const tabsModule = main.find(e => e.meta && e.meta.name === 'STORE_TABS');
    if (tabsModule) {
        const tabs = tabsModule.tabs.filter(tab => (
            get(tab, 'textSpans.0.text', null) &&
            get(tab, 'action.params.regionKey', null)
        ));
        tabs.forEach(tab => {
            tab.regionKey = get(tab, 'action.params.regionKey', '');
            tab.panelId = `str-tabpanel-${tab.regionKey.toLowerCase()}`;
            tab.tabId = `str-tab-${tab.regionKey.toLowerCase()}`;
        });
        if (tabs.length) {
            tabs[0].isSelected = true;
        }
    }
}

function addMetaData(input, resp) {
    if (input) {
        input.meta = {
            isSmall: get(resp, 'meta.isSmall', false)
        };
    }
}
